export const ComponentEnum = [
    {
        id: "wysiwyg",
        name: "Wysiwyg",
        fields: [
            { name: "id", label: "Id", required: true },
            { name: "expandable", label: "Expandable", required: false, type: "select", defaultValue: "no", options: [{ label: "No", value: "no"}, { label: "Yes", value: "yes"}]},
            { name: "content", label: "Content", required: true, type: "wysiwyg" }
        ]
    },
    {
        id: "catalogList",
        name: "Catalog List",
        fields: [
            { name: "id", label: "Id", required: true },
            { name: "items", label: "Items", required: true, type: "array", additional: [
                { name: "title", label: "Title", required: true },
                { name: "image", label: "Image", required: true, type: "image"},
                { name: "link", label: "Link", required: false, type: "file" }             
            ]}           
        ]
    },
    {
        id: "catalogRedCard",
        name: "Catalog Red Card",
        fields: [
            { name: "id", label: "Id", required: true },
            { name: "title", label: "Title", required: true },
            { name: "description", label: "Description", required: true, type: "multiline" },
            { name: "image", label: "Image", required: true, type: "image"},
            { name: "button_one_link", label: "Button One Link", required: false, type: "file" },
            { name: "button_one_label", label: "Button One Label", required: false },
            { name: "button_two_link", label: "Button Two Link", required: false, type: "file" },
            { name: "button_two_label", label: "Button Two Label", required: false }
        ]
    },
    {
        id: "catalogLinks",
        name: "Catalog Links",
        fields: [
            { name: "id", label: "Id", required: true },
            { name: "title", label: "Title", required: true },
            { name: "icon", label: "Icon", required: true, type: "image"},
            { name: "items", label: "Items", required: true, type: "array", additional: [
                { name: "label", label: "Label", required: true },
                { name: "link", label: "Link", required: false, type: "file" }             
            ]}           
        ]
    },
    {
        id: "contactCard",
        name: "Contact Card",
        fields: [
            { name: "id", label: "Id", required: true },
            { name: "title", label: "Title", required: true },
            { name: "description", label: "Description", required: true, type: "multiline" },
            { name: "banner_image", label: "Banner Image", required: true, type: "image"},
            { name: "background_image", label: "Background Image", required: true, type: "image"},
            { name: "map_description", label: "Map Description", required: true, type: "multiline" },
            { name: "map_label", label: "Map Label", required: true },
            { name: "map_link", label: "Map Link", required: false }
        ]
    },
    {
        id: "contactList",
        name: "Contact List",
        fields: [
            { name: "id", label: "Id", required: true }, 
            { name: "items", label: "Items", required: true, type: "array", additional: [
                { name: "icon", label: "Icon", required: true, type: "image"},
                { name: "name", label: "Name", required: true },
                { name: "job_title", label: "Job Title", required: true },
                { name: "email", label: "Email", required: false },
                { name: "phone", label: "Phone", required: false },          
            ]}           
        ]
    },
    {
        id: "pripremaCard",
        name: "Priprema Card",
        fields: [
            { name: "id", label: "Id", required: true }, 
            { name: "title", label: "Title", required: true },
            { name: "items", label: "Items", required: true, type: "array", additional: [
                { name: "icon", label: "Icon", required: true, type: "image"},
                { name: "name", label: "Name", required: true },
                { name: "details", label: "Details", required: true, type: "multiline" }         
            ]}           
        ]
    },
    {
        id: "pripremaList",
        name: "Priprema List",
        fields: [
            { name: "id", label: "Id", required: true }, 
            { name: "title", label: "Title", required: true },
            { name: "items", label: "Items", required: true, type: "array", additional: [
                { name: "color", label: "Color", required: true, type: "color" },
                { name: "name", label: "Name", required: true },
                { name: "value", label: "Value", required: true },
                { name: "description", label: "Description", required: true, type: "multiline" }         
            ]}           
        ]
    },
    {
        id: "portfolioSections",
        name: "Portfolio Sections",
        fields: [
            { name: "id", label: "Id", required: true }, 
            { name: "items", label: "Items", required: true, type: "array", additional: [
                { name: "icon", label: "Icon", required: true, type: "image"},
                { name: "title", label: "Title", required: true },
                { name: "description", label: "Description", required: true, type: "multiline" }        
            ]}           
        ]
    },
    {
        id: "partnerList",
        name: "Partner List",
        fields: [
            { name: "id", label: "Id", required: true }, 
            { name: "items", label: "Items", required: true, type: "array", additional: [
                { name: "icon", label: "Icon", required: true, type: "image"},
                { name: "link", label: "Link", required: false },
                { name: "name", label: "Name", required: false }    
            ]}           
        ]
    },
    {
        id: "imageCards",
        name: "Image Cards",
        fields: [
            { name: "id", label: "Id", required: true }, 
            { name: "items", label: "Items", required: true, type: "array", additional: [
                { name: "image", label: "Image", required: true, type: "image"},
                { name: "title", label: "Title", required: false },
                { name: "link", label: "Link", required: false, type: "file" }         
            ]}           
        ]
    },
    {
        id: "portfolioList",
        name: "Portfolio List",
        fields: [
            { name: "id", label: "Id", required: true }, 
            { name: "items", label: "Items", required: true, type: "array", additional: [
                { name: "image", label: "Image", required: true, type: "image"},
                { name: "title", label: "Title", required: true },
                { name: "description", label: "Description", required: true, type: "multiline" }        
            ]}           
        ]
    },
    {
        id: "opremaSections",
        name: "Oprema Sections",
        fields: [
            { name: "id", label: "Id", required: true }, 
            { name: "items", label: "Items", required: true, type: "array", additional: [
                { name: "icon", label: "Icon", required: true, type: "image"},
                { name: "title", label: "Title", required: true },
                { name: "description", label: "Description", required: true, type: "multiline" }        
            ]}           
        ]
    },
    {
        id: "opremaCard",
        name: "Oprema Card",
        fields: [
            { name: "id", label: "Id", required: true },
            { name: "title", label: "Title", required: true },
            { name: "background_image", label: "Background Image", required: true, type: "image"},
            { name: "description", label: "Description", required: true, type: "multiline" },
        ]
    },
    {
        id: "opremaList",
        name: "Oprema List",
        fields: [
            { name: "id", label: "Id", required: true }, 
            { name: "items", label: "Items", required: true, type: "array", additional: [
                { name: "image", label: "Image", required: true, type: "image"},
                { name: "title", label: "Title", required: true },
                { name: "description", label: "Description", required: true, type: "multiline" }        
            ]}           
        ]
    },
    {
        id: "featuredProductSection",
        name: "Featured Product Section",
        fields: [
            { name: "id", label: "Id", required: true },
            { name: "title", label: "Title", required: false },
            { name: "products", label: "Products", required: true, type: "array", additional: [
                { name: "product", label: "Product", required: true, type: "product"}        
            ]}
        ]
    },
    {
        id: "featuredCategorySection",
        name: "Featured Category Section",
        fields: [
            { name: "id", label: "Id", required: true },
            { name: "title", label: "Title", required: false },
            { name: "categories", label: "Categories", required: true, type: "array", additional: [
                { name: "category", label: "Category", required: true, type: "category"}        
            ]}
        ]
    },
    {
        id: "primeriStampe",
        name: "Primeri Stampe",
        fields: [
            { name: "id", label: "Id", required: true }, 
            { name: "title", label: "Title", required: true },
            { name: "description", label: "Description", required: true },   
            { name: "items", label: "Items", required: true, type: "array", additional: [
                { name: "image", label: "Image", required: true, type: "image"},
                { name: "image_final", label: "Final Image", required: true, type: "image"},
            ]}           
        ]
    },
    {
        id: "brandsList",
        name: "Brands List",
        fields: [
            { name: "id", label: "Id", required: true }, 
            { name: "title", label: "Title", required: true },
            { name: "items", label: "Items", required: true, type: "array", additional: [
                { name: "icon", label: "Icon", required: true, type: "image"},
                { name: "name", label: "Name", required: false },       
            ]}            
        ]
    },
    {
        id: "clientList",
        name: "Client List",
        fields: [
            { name: "id", label: "Id", required: true }, 
            { name: "title", label: "Title", required: true },
            { name: "background_image", label: "Background Image", required: true, type: "image"},
            { name: "items", label: "Items", required: true, type: "array", additional: [
                { name: "icon", label: "Icon", required: true, type: "image"},
                { name: "name", label: "Name", required: false },       
            ]}            
        ]
    },
    {
        id: "testimonials",
        name: "Testimonials",
        fields: [
            { name: "id", label: "Id", required: true }, 
            { name: "title", label: "Title", required: true },
            { name: "items", label: "Items", required: true, type: "array", additional: [
                { name: "title", label: "Title", required: true },
                { name: "statement", label: "Statement ", required: true, type: "multiline" },       
                { name: "name", label: "Name", required: true },
                { name: "company", label: "Company", required: false },
                { name: "link", label: "Link", required: false }  
            ]}            
        ]
    },
    {
        id: "newsletter",
        name: "Newsletter",
        fields: [
            { name: "id", label: "Id", required: true },
            { name: "title", label: "Title", required: true },
        ]
    },
    {
        id: "faq",
        name: "FAQ",
        fields: [
            { name: "id", label: "Id", required: true },
            { name: "title", label: "Title", required: true },
            { name: "category", label: "Category", required: false, type: "faqCategory"}
        ]
    },
    {
        id: "contactForm",
        name: "ContactForm",
        fields: [
            { name: "id", label: "Id", required: true },
            { name: "title", label: "Title", required: true },
        ]
    },
    {
        id: "categoriesSection",
        name: "Categories Section",
        fields: [
            { name: "id", label: "Id", required: true },
            { name: "show_filters", label: "Show Filters", required: false, type: "select", defaultValue: "yes", options: [{ label: "No", value: "no"}, { label: "Yes", value: "yes"}]},
            { name: "products", label: "Products", required: false, type: "products"}
        ]
    },
    {
        id: "mainTitle",
        name: "Main Title",
        fields: [
            { name: "id", label: "Id", required: true },
            { name: "title", label: "Title", required: true },
        ]
    },
    {
        id: "bannerImages",
        name: "Banner Images",
        fields: [
            { name: "id", label: "Id", required: true }, 
            { name: "items", label: "Items", required: true, type: "array", additional: [
                { name: "image", label: "Image", required: true, type: "image"},
                { name: "alt", label: "Alt", required: false },
                { name: "link", label: "Link", required: false }            
            ]}           
        ]
    },
    {
        id: "oNamaTree",
        name: "O name - tree",
        fields: [
            { name: "id", label: "Id", required: true }, 
            { name: "items", label: "Items", required: true, type: "array", additional: [
                { name: "image", label: "Image", required: true, type: "image"},
                { name: "year", label: "Year", required: true },
                { name: "title", label: "Title", required: true },
                { name: "description", label: "Description", required: false, type: "multiline" }            
            ]}           
        ]
    },
    {
        id: "oNamaKakoIzgledamo",
        name: "O nama - kako izgledamo",
        fields: [
            { name: "id", label: "Id", required: true }, 
            { name: "title", label: "Title", required: true },
            { name: "items", label: "Items", required: true, type: "array", additional: [
                { name: "image", label: "Image", required: true, type: "image"},   
            ]}           
        ]
    },
    {
        id: "oNamaBlock",
        name: "O nama - Block",
        fields: [
            { name: "id", label: "Id", required: true }, 
            { name: "title", label: "Title", required: true },
            { name: "description", label: "Description", required: true, type: "wysiwyg" },
            { name: "image", label: "Image", required: true, type: "image"}         
        ]
    },
    {
        id: "oNamaKontrola",
        name: "O nama - Kontrola",
        fields: [
            { name: "id", label: "Id", required: true }, 
            { name: "title", label: "Title", required: true },
            { name: "description", label: "Description", required: true, type: "wysiwyg" },
            { name: "image", label: "Image", required: true, type: "image"}, 
            { name: "image_two", label: "Image Two", required: true, type: "image"}        
        ]
    },
    {
        id: "oNamaBlockTwo",
        name: "O nama - Block Two",
        fields: [
            { name: "id", label: "Id", required: true }, 
            { name: "title", label: "Title", required: true },
            { name: "description", label: "Description", required: true, type: "wysiwyg" },
            { name: "image", label: "Image", required: true, type: "image"}      
        ]
    },
    {
        id: "oNamaBlockNormalIcons",
        name: "O nama - Block Normal Icons",
        fields: [
            { name: "id", label: "Id", required: true }, 
            { name: "title", label: "Title", required: true },
            { name: "description", label: "Description", required: true, type: "wysiwyg" },
            { name: "items", label: "Items", required: true, type: "array", additional: [
                { name: "icon", label: "Icon", required: true, type: "image"},   
            ]}     
        ]
    },
    {
        id: "oNamaBlockThree",
        name: "O nama - Block Three",
        fields: [
            { name: "id", label: "Id", required: true }, 
            { name: "title", label: "Title", required: true },
            { name: "description", label: "Description", required: true, type: "wysiwyg" },
            { name: "image", label: "Image", required: true, type: "image"}      
        ]
    },
    {
        id: "oNamaBlockNormal",
        name: "O nama - Block Normal",
        fields: [
            { name: "id", label: "Id", required: true }, 
            { name: "title", label: "Title", required: true },
            { name: "description", label: "Description", required: true, type: "wysiwyg" },
            { name: "image", label: "Image", required: true, type: "image"}      
        ]
    }
]